import { FC } from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark,
  },
  icon: {
    marginTop: 2,
  },
}));

export type FormErrorBannerProps = {
  message: string;
};

/** Inline non-blocking error message shown above forms when a mutation fails. */
const FormErrorBanner: FC<FormErrorBannerProps> = ({ message }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} role='alert'>
      <ErrorOutlineIcon className={classes.icon} fontSize='small' />
      <Typography variant='body2'>{message}</Typography>
    </Box>
  );
};

export default FormErrorBanner;
